import { useEffect, useState } from "react";

const GUIDE_KEY = "pipeline_guide_seen";

export function usePipelineGuide() {
  const [stepIndex, setStepIndex] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    const seen = localStorage.getItem(GUIDE_KEY);
    if (!seen) {
      setIsActive(true);
    }
  }, []);

  const nextStep = () => {
    setStepIndex((prev) => prev + 1);
  };

  const endGuide = () => {
    localStorage.setItem(GUIDE_KEY, "true");
    setIsActive(false);
  };

  return {
    stepIndex,
    isActive,
    nextStep,
    endGuide,
  };
}